module.exports = __webpack_public_path__ + "static/media/wordmark.65ad571b.png";